import React from "react";
import PropTypes from "prop-types";

import { Button } from "cxa-components";
import { DataTable } from "@cxagroup/casper";
import { formatWithHardcodedCurrency } from "components/common/FormattedComponents";
import CheckoutItemsFootnote from "./CheckoutItemsFootnote";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";
import StandardMoney from "../../../common/StandardMoney";

const headers = [
  messages.productDescription,
  messages.descriptionDescription,
  messages.HDFDescription,
  messages.priceDescription,
];

const BenefitCheckoutResponsiveTable = ({ intl, items, subTotal, currency }) =>
  !!items.length && (
    <div className="apl-responsive-table">
      <DataTable
        headers={headers.map(msg => intl.formatMessage(msg))}
        rows={items.map(
          (
            {
              name,
              planNameMessageDescription,
              displayValue,
              showUWSumAssured,
              guaranteed,
              subjectToUW,
              uWFormID,
              total: { price: { numericValue } = {} } = {},
            },
            key
          ) => [
            <h5 key={key}>
              <FormattedMessage id={name} defaultMessage={name} />
            </h5>,
            // nasty bit - this combines (6 - 1) table cells from legacy table's 3 different rows together. HDF form link goes to another cell
            <section key={key}>
              <h5>
                <FormattedMessage {...planNameMessageDescription} />
              </h5>
              <p>
                <FormattedMessage {...messages.optionTextDescription} /> {displayValue}
                {displayValue && " "}
              </p>
              {!!(showUWSumAssured && guaranteed) && (
                <p>
                  <FormattedMessage {...messages.guaranteedSumDescription} />
                  {formatWithHardcodedCurrency(guaranteed.label.numericValue)}{" "}
                  <StandardMoney
                    value={guaranteed.price.numericValue}
                    currency={currency}
                    className="apl-field__currency"
                  />
                </p>
              )}
              {!!(showUWSumAssured && subjectToUW) && (
                <p>
                  <FormattedMessage {...messages.underwritingSumDescription} />
                  {formatWithHardcodedCurrency(subjectToUW.label.numericValue)}{" "}
                  <StandardMoney
                    value={subjectToUW.price.numericValue}
                    currency={currency}
                    className="apl-field__currency"
                  />
                </p>
              )}
            </section>,
            uWFormID ? (
              <Button
                onClick={() => {
                  // eslint-disable-next-line security/detect-non-literal-fs-filename
                  window.open(`/hdf/${uWFormID}`, "hdfWindow");
                }}
              >
                <FormattedMessage {...messages.HDFDescription} />
              </Button>
            ) : null,
            <StandardMoney
              key={key}
              value={numericValue}
              currency={currency}
              className="apl-field__currency"
            />,
          ]
        )}
      />
      <CheckoutItemsFootnote subTotal={subTotal} currency={currency} />
    </div>
  );

BenefitCheckoutResponsiveTable.propTypes = {
  items: PropTypes.array.isRequired,
  currency: PropTypes.string,
};

export default BenefitCheckoutResponsiveTable;



// WEBPACK FOOTER //
// ./components/employee/shop/checkout/BenefitCheckoutResponsiveTable.js